const getConfiguracion = async () => {
  return {
    tipoControl: "Voluntario",
    tipoControlDescripcion: "voluntario",
    cantidadArticulosControlAlAzar: 1000,
    mostrarStockTeorico: true,
    buscarEnSinonimos: true,
    buscarEnCodigo: true,
    msgError: "",
  };
};

const getArticuloIMAPorCodigoDeBarras = async ({ codBarra, buscarEnSinonimos, buscarEnCodigo }) => {
  // Datos hardcodeados para expo - Artículos de estación de servicio
  if (!codBarra || codBarra.trim() === "") {
    return {
      msgError: "Código de barras no válido",
    };
  }

  // Catálogo de artículos para estación de servicio
  const articulos = {
    // BEBIDAS
    7790315000446: {
      codigo: "COCA-500",
      codigoBarra: "7790315000446",
      idArticulo: 8421,
      descripcion: "Coca Cola 500ml",
      ubicacion: "Heladera Principal",
      msgError: "",
    },
    7790315000149: {
      codigo: "AGUA-500",
      codigoBarra: "7790315000149",
      idArticulo: 8422,
      descripcion: "Agua Mineral 500ml",
      ubicacion: "Heladera Principal",
      msgError: "",
    },
    7896004009193: {
      codigo: "PASTILLAS HALLS",
      codigoBarra: "203",
      idArticulo: 5282,
      descripcion: "PASTILLAS HALLS",
      ubicacion: "Góndola Dulces B-1",
      msgError: "",
    },

    // SNACKS
    7795930002097: {
      codigo: "CHICLES BELDENT",
      codigoBarra: "301",
      idArticulo: 8431,
      descripcion: "CHICLES BELDENT",
      ubicacion: "Góndola A-1",
      msgError: "",
    },
    7790895645778: {
      codigo: "PAPAS LAYS",
      codigoBarra: "302",
      idArticulo: 8432,
      descripcion: "PAPAS LAYS",
      ubicacion: "Góndola Salados B-2",
      msgError: "",
    },
  };

  // Buscar artículo por código exacto
  const articulo = articulos[codBarra];

  if (articulo) {
    return articulo;
  }

  // Si no encuentra el código específico, devolver artículo genérico
  return {
    codigo: codBarra,
    codigoBarra: codBarra,
    idArticulo: 8499,
    descripcion: "No se encontró el artículo",
    ubicacion: "Depósito General",
    msgError: "",
  };
};

const getMovimientoStock = async (idArticulo, idDeposito) => {
  // Datos hardcodeados para expo
  return [
    {
      idTipoMovimiento: "AJI",
      descripcion: "Ajuste por Inventario",
      fecha: "2024-01-15",
      cantidad: 150,
      observaciones: "Ajuste inicial de stock",
    },
    {
      idTipoMovimiento: "VEN",
      descripcion: "Venta",
      fecha: "2024-01-16",
      cantidad: -5,
      observaciones: "Venta directa",
    },
  ];
};

const persistirAjustes = async (idEmpleado, idDeposito, movimientos) => {
  // Simulación hardcodeada para expo
  console.log("Ajustes guardados exitosamente:", { idEmpleado, idDeposito, movimientos });

  // Guardar los nuevos stocks ajustados en localStorage para persistencia
  const stocksAjustados = JSON.parse(localStorage.getItem("stocksAjustados")) || {};

  movimientos.forEach(movimiento => {
    stocksAjustados[movimiento.idArticulo] = movimiento.stockReal;
    console.log(`Stock actualizado - Artículo ${movimiento.idArticulo}: ${movimiento.stockReal}`);
  });

  localStorage.setItem("stocksAjustados", JSON.stringify(stocksAjustados));

  return {
    success: true,
    message: "Ajustes guardados correctamente",
    movimientos: movimientos.length,
    msgError: "",
  };
};

const getArticuloIMAPorId = async idArticulo => {
  // Datos hardcodeados para expo - Buscar artículo por ID
  const articulosPorId = {
    // COMBUSTIBLES

    8402: {
      codigo: "DIESEL-500",
      codigoBarra: "002",
      idArticulo: 8402,
      descripcion: "Gasoil Infinia Diesel",
      ubicacion: "Surtidor 1-4",
      msgError: "",
    },
    8403: {
      codigo: "GNC-M3",
      codigoBarra: "003",
      idArticulo: 8403,
      descripcion: "Gas Natural Comprimido",
      ubicacion: "Surtidor GNC",
      msgError: "",
    },

    // BEBIDAS
    8421: {
      codigo: "COCA-500",
      codigoBarra: "7790315000446",
      idArticulo: 8421,
      descripcion: "Coca 500ml",
      ubicacion: "Heladera Principal",
      msgError: "",
    },
    8422: {
      codigo: "AGUA-500",
      codigoBarra: "202",
      idArticulo: 8422,
      descripcion: "Agua Mineral 500ml",
      ubicacion: "Heladera Principal",
      msgError: "",
    },

    // SNACKS
    8431: {
      codigo: "PAPAS-150",
      codigoBarra: "203",
      idArticulo: 8431,
      descripcion: "Papas Fritas Clásicas 150g",
      ubicacion: "Góndola Snacks A-1",
      msgError: "",
    },
    8432: {
      codigo: "CHOCO-45",
      codigoBarra: "204",
      idArticulo: 8432,
      descripcion: "Chocolate Milka 45g",
      ubicacion: "Góndola Dulces B-2",
      msgError: "",
    },
  };

  const articulo = articulosPorId[idArticulo];

  if (articulo) {
    return articulo;
  }

  // Artículo genérico si no encuentra el ID
  return {
    codigo: "GENERICO",
    codigoBarra: "999",
    idArticulo: idArticulo,
    descripcion: "Artículo Genérico de Estación",
    ubicacion: "Depósito General",
    msgError: "",
  };
};

const getStockTeoricoIMA = async (idArticulo, idDeposito, fecha) => {
  // Verificar primero si hay stocks ajustados guardados
  const stocksAjustados = JSON.parse(localStorage.getItem("stocksAjustados")) || {};

  // Si ya fue ajustado, usar el nuevo valor
  if (stocksAjustados[idArticulo] !== undefined) {
    console.log(`Usando stock ajustado para artículo ${idArticulo}: ${stocksAjustados[idArticulo]}`);
    return {
      stockTeorico: stocksAjustados[idArticulo],
      msgError: "",
    };
  }

  // Si no fue ajustado, usar valores hardcodeados iniciales
  const stockPorTipoArticulo = {
    // COMBUSTIBLES - Stock muy alto
    8401: 15000, // Nafta V-Power
    8402: 12000, // Gasoil
    8403: 8000, // GNC

    // BEBIDAS - Stock alto (rotación rápida)
    8421: 120, // Coca Cola
    8422: 96, // Agua
    8423: 48, // Gatorade

    // SNACKS - Stock medio
    8431: 72, // Papas Lays
    8432: 84, // Chocolate Milka
    8433: 36, // Maní

    // ACCESORIOS AUTO - Stock bajo
    8441: 15, // Fusibles
    8442: 8, // Limpiaparabrisas
    8443: 12, // Lámparas H7

    // PRODUCTOS LIMPIEZA - Stock medio
    8451: 25, // Shampoo auto
    8452: 18, // Cera líquida
  };

  const stock = stockPorTipoArticulo[idArticulo] || 50; // Stock genérico si no encuentra

  return {
    stockTeorico: stock,
    msgError: "",
  };
};

const getListaArticulosIMA = async idDeposito => {
  // Datos hardcodeados para expo - Catálogo de estación de servicio
  return [
    // COMBUSTIBLES
    {
      codigo: "DIESEL-500",
      codigoBarra: "002",
      idArticulo: 8402,
      descripcion: "Gasoil Infinia Diesel",
      ubicacion: "Surtidor 1-4",
      stockTeorico: 12000,
    },

    // BEBIDAS
    {
      codigo: "COCA-500",
      codigoBarra: "7790315000446",
      idArticulo: 8421,
      descripcion: "Coca Cola 500ml",
      ubicacion: "Heladera Principal",
      stockTeorico: 120,
    },
    {
      codigo: "AGUA-500",
      codigoBarra: "202",
      idArticulo: 8422,
      descripcion: "Agua Mineral Villavicencio 500ml",
      ubicacion: "Heladera Principal",
      stockTeorico: 96,
    },

    // SNACKS
    {
      codigo: "PAPAS-150",
      codigoBarra: "301",
      idArticulo: 8431,
      descripcion: "Papas Fritas Lays Clásicas 150g",
      ubicacion: "Góndola Snacks A-1",
      stockTeorico: 72,
    },
    {
      codigo: "CHOCO-45",
      codigoBarra: "302",
      idArticulo: 8432,
      descripcion: "Chocolate Milka Oreo 45g",
      ubicacion: "Góndola Dulces B-2",
      stockTeorico: 84,
    },
    {
      codigo: "CERA-AUTO",
      codigoBarra: "502",
      idArticulo: 8452,
      descripcion: "Cera Líquida Protectora 500ml",
      ubicacion: "Estante Limpieza D-2",
      stockTeorico: 18,
    },
  ];
};

// Función adicional para limpiar datos de expo
const limpiarDatosExposicion = () => {
  localStorage.removeItem("stocksAjustados");
  console.log("Datos de expo limpiados - stocks reiniciados a valores originales");
};

const inventario = {
  getConfiguracion,
  getStockTeoricoIMA,
  getArticuloIMAPorCodigoDeBarras,
  getMovimientoStock,
  persistirAjustes,
  getArticuloIMAPorId,
  getListaArticulosIMA,
  limpiarDatosExposicion, // Función para limpiar datos de expo
};

export default inventario;
